import type { ReactNode } from 'react';
import React, { useEffect, useRef } from 'react';
type Props = {
  children: ReactNode;
  className?: string;
  onClick: () => void;
  shard?: {
    current: HTMLElement | null | undefined;
  };
};
export const ClickOutside = ({ children, className, onClick, shard = {}, ...rest }: Props) => {
  const ref: {
    current: HTMLElement | null | undefined;
  } = useRef(null);
  useEffect(() => {
    const onClickOutside = (e: React.SyntheticEvent) => {
      const { current } = ref;
      const { current: shardElement } = shard;
      const clickedElement = e.target;
      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return () => {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return (
    <div {...rest} className={className} ref={ref}>
      {children}
    </div>
  );
};
